import { useState, useEffect } from "react";
import AddChoice from "./AddChoice";
import { toast } from "react-toastify";
import { __API_URL__ } from "../../SERVER_URL";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const AddQuestion = ({
  AllQuestionsDropdown,
  setNewQuestion,
  newQuestion,
  setEditQuestion,
  editQuestion,
  questionIndex,
  handleChoicesFromSurvey,
}) => {
  const token = localStorage.getItem("token");
  const [question, setQuestion] = useState({
    choice: [],
  });
  const [newChoice, setNewChoice] = useState(false);
  const [editChoice, setEditChoice] = useState("");
  const [photoType, setPhotoType] = useState([]);
  const [allChoice, setAllChoice] = useState([]);
  const [choiceCount, setChoiceCount] = useState([1]);
  const [choiceList, setChoiceList] = useState([]);
  const [changeChoice, setChangeChoice] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [disableOrderNumber, setDisableOrderNumber] = useState(true);
  const [choiceIndex, setChoiceIndex] = useState(-1);

  const handleChoices = (e, index) => {
    const { label, value } = e;
    setDisableOrderNumber(false);
    const choiceArray = question?.choice ? [...question.choice] : [];

    if (index >= 0 && index < choiceArray.length) {
      choiceArray[index] = { label: label, value: value };
      if (!choiceArray[index].order) choiceArray[index]["order"] = index + 1;
    } else {
      choiceArray.push({ label: label, value: value, order_number: index + 1 });
    }
    setQuestion({
      ...question,
      choice: choiceArray,
    });

    setChangeChoice(true);
    setDisabled(false);
  };

  const handleOrderNumber = (e, index) => {
    const ChoiceArray = question?.choice ? [...question.choice] : [];

    if (index >= 0 && index < ChoiceArray.length) {
      ChoiceArray[index] = {
        ...ChoiceArray[index],
        order_number: e.target.value,
      };
    } else {
      ChoiceArray.push({ order_number: e.target.value });
    }
    setQuestion({
      ...question,
      choice: ChoiceArray,
    });
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === "type") {
      setQuestion({
        ...question,
        type: value === "Multi-choice" ? "Choice" : value,
        multi_choice: value === "Multi-choice",
      });
    } else {
      setQuestion({
        ...question,
        [name]: value,
      });
    }
  };

  const handleEdit = (value) => {
    setEditChoice(value);
    setNewChoice(true);
  };

  const handleNewChoice = (index) => {
    setNewChoice(true);
    setChoiceIndex(index);
  };

  const handleAddChoice = () => {
    const nextValue = choiceCount[choiceCount.length - 1] + 1;
    const updatedChoiceCount = [...choiceCount, nextValue];
    setChoiceCount(updatedChoiceCount);
    setDisabled(true);
    setDisableOrderNumber(true);
  };

  const handleRemoveChoice = (index) => {
    if (choiceCount.length === 1) {
      toast.error("At least one choice is necessary.");
    } else {
      const updatedChoiceCount = choiceCount.slice();
      updatedChoiceCount.splice(index, 1);

      setChoiceCount(updatedChoiceCount);

      setQuestion((prevQuestion) => {
        const updatedChoice = prevQuestion.choice.slice();
        updatedChoice.splice(index, 1);

        return {
          ...prevQuestion,
          choice: updatedChoice,
        };
      });
    }
  };

  const AllPhotoType = () => {
    axios
      .get(`${__API_URL__}/api/photos/visit-photo-types/web/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => {
        setPhotoType(res.data);
      })
      .catch(() => {
        console.log("Something Went Wrong");
      });
  };

  const AllChoices = () => {
    axios
      .post(
        `${__API_URL__}/api/survey/get_choices`,
        { choices: question?.choice },
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((res) => {
        setAllChoice(res.data);
        setChangeChoice(false);
      })
      .catch(() => {
        console.log("Something Went Wrong");
      });
  };

  const CreateQuestion = (e) => {
    e.preventDefault();
    if (editQuestion?.value) {
      axios
        .patch(
          `${__API_URL__}/api/survey/edit_question/${editQuestion?.value}/`,
          { ...question, choices: choiceList },
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        )
        .then(() => {
          toast.success("Question Updated");
          AllQuestionsDropdown();
          setChangeChoice(false);
          setNewQuestion(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something Went Wrong");
        });
    } else {
      axios
        .post(
          `${__API_URL__}/api/survey/create_question`,
          { ...question, choices: choiceList },
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        )
        .then((res) => {
          toast.success("Question Added");
          AllQuestionsDropdown();
          setNewQuestion(false);
          handleChoicesFromSurvey({ label: res.data.question, value: res.data.id }, questionIndex);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something Went Wrong");
        });
    }
  };

  const getSingleQuestion = () => {
    axios
      .get(`${__API_URL__}/api/survey/get_single_question/${editQuestion?.value}`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => {
        setQuestion(res.data);
      });
  };

  useEffect(() => {
    const choiceKeys = Object.keys(question).filter((key) => key.startsWith("Choice"));
    const list = choiceKeys.map((key) => ({ [key]: question[key] }));
    setChoiceList(list);
  }, [question]);

  useEffect(() => {
    AllPhotoType();
  }, []);

  useEffect(() => {
    AllChoices();
  }, [changeChoice]);

  useEffect(() => {
    if (editQuestion?.value) {
      getSingleQuestion();
      setDisabled(false);
      setDisableOrderNumber(false);
    }
  }, [editQuestion]);

  useEffect(() => {
    if (question.choice && Array.isArray(question.choice) && editQuestion?.value) {
      const newQuestionCount = Array.from(
        { length: question.choice.length },
        (_, index) => index + 1
      );
      setChoiceCount(newQuestionCount);
    }
  }, [question]);

  const isOptEqual = (option, value) => option.value === value.value;

  return (
    <>
      <Dialog
        open={newQuestion}
        onClose={() => {
          setNewQuestion(false);
          setEditQuestion({});
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {editQuestion?.value ? "Edit Question" : "Add Question"}
          <IconButton
            aria-label="close"
            onClick={() => {
              setNewQuestion(false);
              setEditQuestion({});
            }}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <form id="question-form" onSubmit={CreateQuestion}>
            <TextField
              label="Question"
              name="question"
              fullWidth
              margin="normal"
              size="small"
              value={question?.question || ""}
              onChange={handleFieldChange}
              placeholder="Enter question"
              required
              className="question-question"
            />

            <TextField
              label="Label"
              name="label"
              fullWidth
              margin="normal"
              size="small"
              value={question?.label || ""}
              onChange={handleFieldChange}
              placeholder="Enter label"
              className="question-label"
            />

            <FormControl fullWidth margin="normal" size="small">
              <InputLabel id="photo-type-label">Photo Type</InputLabel>
              <Select
                labelId="photo-type-label"
                label="Photo Type"
                name="photo_type"
                value={question?.photo_type || ""}
                onChange={handleFieldChange}
                className="question-photo-type"
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                {photoType?.map((photo) => (
                  <MenuItem key={photo.id} value={photo.id}>
                    {photo.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal" size="small">
              <InputLabel id="question-type-label">Type</InputLabel>
              <Select
                labelId="question-type-label"
                label="Type"
                name="type"
                value={question.multi_choice ? "Multi-choice" : question.type || "Choice"}
                onChange={handleFieldChange}
                className="question-type"
              >
                <MenuItem value="Choice">Choice</MenuItem>
                <MenuItem value="Rating">Rating</MenuItem>
                <MenuItem value="Multi-choice">Multi-choice</MenuItem>
              </Select>
            </FormControl>

            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
              Choice
            </Typography>

            {choiceCount?.map((choice, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 1,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Autocomplete
                    value={question?.choice[index] || null}
                    options={allChoice || []}
                    getOptionLabel={(o) => o.label || ""}
                    isOptionEqualToValue={isOptEqual}
                    onChange={(_e, val) => {
                      if (val) handleChoices(val, index);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`Choice ${index + 1}`}
                        size="small"
                        className={`question-choice-${index}`}
                      />
                    )}
                  />
                </Box>
                <TextField
                  type="number"
                  label="Order"
                  size="small"
                  sx={{ width: 80 }}
                  inputProps={{ min: 0 }}
                  name="order_number"
                  value={question?.choice[index]?.order_number || ""}
                  disabled={disableOrderNumber}
                  required
                  onChange={(e) => handleOrderNumber(e, index)}
                  className={`question-choice-${index}-order`}
                />
                <IconButton
                  size="small"
                  onClick={() => handleEdit(question?.choice?.[index], index)}
                  className="question-edit"
                >
                  <EditTwoToneIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleNewChoice(index)}
                  className="question-add"
                >
                  <AddIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleRemoveChoice(index)}
                  className="question-delete"
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}

            <Button
              variant="outlined"
              size="small"
              disabled={disabled}
              onClick={handleAddChoice}
              sx={{ mt: 1 }}
              className="question-add-row"
            >
              Add row
            </Button>
          </form>
        </DialogContent>
        <DialogActions>
          <Button type="submit" form="question-form" variant="contained" className="question-save">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {newChoice && (
        <AddChoice
          setNewChoice={setNewChoice}
          toast={toast}
          AllChoices={AllChoices}
          setEditChoice={setEditChoice}
          editChoice={editChoice}
          choiceIndex={choiceIndex}
          handleChoices={handleChoices}
        />
      )}
    </>
  );
};
export default AddQuestion;
